// @flow
import {useDispatch} from 'react-redux'
import * as actions from '../../actions/actions'
import {useCallback} from "react";
import {getCurrentUserPermissions} from "../../modules/permission/actions/actions";

const useUserAction = () => {
    const dispatch = useDispatch()

    const checkAPIConnectivity = useCallback(() => {
        dispatch(actions.checkAPIConnectivity())
    }, [dispatch])

    const userLogin = useCallback((values) => {
        const bodyFormData = new FormData();
        bodyFormData.append('username', values.username);
        bodyFormData.append('password', values.password);
        dispatch(actions.userLogin(bodyFormData))
    }, [dispatch])

    const userLogout = useCallback(() => {
        dispatch(actions.userLogout())
    }, [dispatch])

    const setUserLanguage = useCallback((language) => {
        dispatch(actions.setUserLanguage(language))
    }, [dispatch])

    const getUserPermissions = useCallback(() => {
        dispatch(getCurrentUserPermissions())
    }, [dispatch])
    
    const setUserMessage = useCallback((message) => {
        dispatch(actions.setUserMessage(message))
    }, [dispatch])

    return {
        checkAPIConnectivity,
        setUserMessage,
        userLogin,
        userLogout,
        setUserLanguage,
        getUserPermissions
    }
}

export default useUserAction